import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import React, { useEffect, useState } from "react";
import { Box } from '@mui/material'
import CustomButton from 'components/atoms/CustomButton'
import { useTranslation } from 'react-i18next'
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Card, Input, Radio, Space } from "antd";
import { Diners, Jcb, UnionPay, Visa, Mastercard, Amex, Discover, Delete, Card as CardIcon } from 'assets/images'
import { useMutation } from 'react-query'
import { addPaymentCard, deleteCard, onAddCardpaymentConfirm, setDefaultCard } from "api";
import { showErrorMessage, showSuccessMessage } from "utils/showMessage";
import { useSelector } from "react-redux";
import ErrorIcon from '@mui/icons-material/Error';
import CircularProgress from '@mui/material/CircularProgress';
import { MaskedInput } from 'antd-mask-input'
import { isExpired } from 'lib/utils';

const ChangePaymentCardModal = ({ show, onClose, onSubmit, cards, companyId }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const is_default = cards?.find(el => el?.is_default)
  const token = useSelector((state) => state.admin.access_token)
  const searchParams = new URLSearchParams(location.search);
  const setupIntent = searchParams.get("setup_intent");
  const [defaultCard, setAsDefaultCard] = useState(is_default?.id);
  const [isLoading, setIsLoading] = useState(false)
  const [isAddCard, setIsAddCard] = useState(false)

  const [loading, setLoading] = useState(false)



  function closeModal() {

    onClose()

  }

  const paymentValidationSchema = Yup.object({
      card_number: Yup.string()
        .matches(/^\d{13,19}$/, t("Invalid card number"))
        .required(t("Required")),
      card_exp_month: Yup.string()
        .matches(/^(0[1-9]|1[0-2])$/, t("Invalid month"))
        .required(`${t("Plans.Month")} ${t("Required")}`),
      card_exp_year: Yup.string()
        .transform(value => (value ? String(value) : ""))
        .matches(/^\d{4}$/, t("Invalid year"))
        .required(`${t("Plans.Year")} ${t("Required")}`).
        test("expDateValid", t("Pay.Card has expired"), function (yearValue) {
          const { card_exp_month } = this.parent;
  
          if (!card_exp_month || !yearValue) return true;
  
          const now = new Date();
          const currentMonth = now.getMonth() + 1;
          const currentYear = now.getFullYear();
  
          const month = parseInt(card_exp_month, 10);
          const year = parseInt(yearValue, 10);
  
          if (isNaN(month) || isNaN(year)) return true;
  
          if (year < currentYear) return false;
          if (year === currentYear && month < currentMonth) return false;
  
          return true;
        }),
      card_cvv: Yup.string()
        .matches(/^\d{3,4}$/, t("Invalid CVV"))
        .required(t("Required")),
      redirect_url: Yup.string().required(t("Required")),
    })

  const paymentValues = {
    card_number: '',
    card_exp_month: 0,
    card_exp_year: 0,
    card_cvv: 0,
    redirect_url: window.location.href
  }

  const formik = useFormik({
    initialValues: () => (paymentValues),
    values: () => (paymentValues),
    validationSchema: () => (paymentValidationSchema),
    onSubmit: (values) => {
      //console.log('values', values);

      //pay.mutate(values)
    },
  });

  const handlePaymentSuccess = (setupIntent) => {
    const setup_intent_id = setupIntent


    if (!isLoading) {
      confirm.mutate({
        setup_intent_id
      })
    }


  }

  const pay = useMutation({
    mutationKey: 'payment-cards',
    onMutate: () => {
      setLoading(true);
    },
    mutationFn: (values) => addPaymentCard(values, token, companyId),
    onSuccess: async (res) => {

      setLoading(false)
      const link = res?.resData?.data?.url

      if (link) {
        window.location.href = link
      } else {
        onSubmit()
        setIsAddCard(false)
        closeModal()
      }

    },
    onError: (err) => {
      setLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const confirm = useMutation({
    mutationKey: 'payment-card/3d-secure-redirect',
    mutationFn: (values) => onAddCardpaymentConfirm(values, token, localStorage.getItem('companyId')),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: async (res) => {
      onSubmit()
      closeModal()

    },
    onError: (err) => {

      setIsLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const setDefault = useMutation({
    mutationKey: 'set-default',
    mutationFn: (cardId) => setDefaultCard(token, companyId, cardId),
    onSuccess: async (res) => {
      showSuccessMessage('Carta impostata come pagamento di default')
      onSubmit()


    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const onDeleteCard = useMutation({
    mutationKey: 'delete-card',
    mutationFn: (cardId) => deleteCard(token, companyId, cardId),
    onSuccess: async (res) => {
      // console.log('res', res);
      onSubmit()


    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const onChange = (e) => {
   // console.log('e.target.value', e.target.value);
    setAsDefaultCard(e.target.value);
   

  };

  const renderCardIcon = (type) => {

    switch (type) {
      case "Visa":
        return <img width={54} src={Visa} alt="visa" />;
      case "Mastercard":
        return <img width={54} src={Mastercard} alt="mastercard" />;
      case "AmericanExpress":
        return <img width={54} src={Amex} alt="amex" />;
      case "Discover":
        return <img width={54} src={Discover} alt="discover" />;
      case "Diners":
        return <img width={54} src={Diners} alt="diners" />;
      case "JCB":
        return <img width={54} src={Jcb} alt="jcp" />;
      case "UnionPay":
        return <img width={54} src={UnionPay} alt="unionpay" />;
      default:
        return <img width={54} src={CardIcon} alt="" />;
    }
  }

  useEffect(() => {

    if (setupIntent) {
      handlePaymentSuccess(setupIntent);
    }
  }, [setupIntent]);

  useEffect(() => {
    const currentUrl = window.location.href;
    formik.setFieldValue('redirect_url', currentUrl)
  }, [])

  useEffect(() => {

    if (is_default?.id) {
      setAsDefaultCard(is_default?.id)
    }

  }, [is_default])



  return (
    <ModalAdmin
      width={448}
      show={show}
      onClose={closeModal}
      title={
        <div className="flex flex-col">

          {cards?.length > 0 ? <span>{t('Pay.UpdatePaymentMethod')}</span> : <span>{t('Pay.AddPaymentMethod')}</span>}



        </div>
      }>
      <Box
        noValidate
        component="form"
        className={`flex flex-col min-h-[466px]`}
      >

        {isAddCard && (
          <form onSubmit={formik.handleSubmit}>

            <div>

              <p className="text-sm font-normal text-[#595961] mt-4">{t("Pay.Number")}</p>
              
              <MaskedInput
                mask="0000 0000 0000 0000"
                maskOptions={{ lazy: true }}
                type="text"
                placeholder="Card Number"
                name="card_number"
                value={formik.values.card_number}
                onChange={(e) => {
                  formik.setTouched({
                    card_number: true,
                  })
                  const value = e.target.value.replace(/\s+/g, '');
                  formik.setFieldValue('card_number', value);
                }}
                rootClassName="placeholder:text-[#FFF] placeholder:opacity-50"
                onBlur={formik.handleBlur}
                style={{
                  color: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.06)',
                  width: '100%',
                  borderRadius: "0px",
                  borderTopLeftRadius: '4px',
                  borderTopRightRadius: '4px',
                  borderBottomLeftRadius: "0px",
                  borderBottomRightRadius: "0px",
                  border: '0px',
                  outline: "none",
                  alignContent: 'center'
                }}
              />
              {formik.touched.card_number && formik.errors.card_number && (
                <p className="text-red-500 text-xs mt-1">{formik.errors.card_number}</p>
              )}


              <div className="flex gap-4">
                <div className="w-full">
                  <p className="text-sm font-normal text-[#595961] mt-4">{t("Pay.Expiration")}</p>
                  <MaskedInput
                    mask="00/0000"
                    maskOptions={{ lazy: true }}
                    placeholder="MM/YYYY"
                    rootClassName="placeholder:text-[#FFF] placeholder:opacity-50"
                    type="text"
                    onChange={(e) => {
                      formik.setTouched({
                        card_exp_month: true,
                        card_exp_year: true,
                      })
                      const [month, year] = e.target.value.split("/").map(String);
                      if (month && year) {
                        formik.setFieldValue('card_exp_month', month?.toString(), true)
                        formik.setFieldValue('card_exp_year', year?.toString())
                      } else {
                        formik.setFieldValue('card_exp_month', '')
                        formik.setFieldValue('card_exp_year', '')
                      }
                    }}
                    style={{
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.06)',
                      width: '100%',
                      borderRadius: "0px",
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px',
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                      border: '0px',
                      outline: "none",
                      alignContent: 'center'
                    }}
                  />
                  {formik.touched.card_exp_month && formik.errors.card_exp_month && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.card_exp_month}</p>
                  )}
                  {formik.touched.card_exp_year && formik.errors.card_exp_year && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.card_exp_year}</p>
                  )}


                </div>

                <div >
                  <p className="text-sm font-normal text-[#595961] mt-4">CVV</p>
                  <MaskedInput
                    mask="0000"
                    maskOptions={{ lazy: true }}
                    placeholder="CVC"
                    type="text"
                    name="card_cvv"
                    value={formik.values.card_cvv}
                    onChange={(e) => {
                      formik.setTouched({
                        card_cvv: true,
                      })
                      const value = e.target.value.replace(/\s+/g, '');
                      formik.setFieldValue('card_cvv', value);
                    }}
                    rootClassName="placeholder:text-[#FFF] placeholder:opacity-50"
                    onBlur={formik.handleBlur}
                    style={{
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.06)',
                      width: '100%',
                      borderRadius: "0px",
                      borderTopLeftRadius: '4px',
                      borderTopRightRadius: '4px',
                      borderBottomLeftRadius: "0px",
                      borderBottomRightRadius: "0px",
                      border: '0px',
                      outline: "none",
                      alignContent: 'center'
                    }}
                  />
                  {formik.touched.card_cvv && formik.errors.card_cvv && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.card_cvv}</p>
                  )}

                </div>
              </div>
            </div>

            {/* Pulsanti */}
            <div className={`flex gap-2 pt-10 justify-end`}>


              <CustomButton
                style={{ flex: '1' }} buttonColor="secondary" onClick={() => {
                  setIsAddCard(false)
                }}>
                {t('Cancel')}
              </CustomButton>
              <CustomButton
                onClick={() => {

                  pay.mutate(formik.values)
                }}
                disabled={!formik.isValid || !formik.dirty || loading}
                style={{ flex: '1' }}

              >
                {t('Add')}
                {loading && (<CircularProgress size="15px" style={{ marginLeft: 8, color: 'white' }} />)}
              </CustomButton>
            </div>



          </form>
        )}


        {!isAddCard && (<>

          {cards?.length > 0 && (
            <>
              <Radio.Group onChange={onChange} value={defaultCard} className="admin-plan-radio">

                <Space direction="vertical" className='w-full'>

                  {cards?.map((el, index) => (
                    <Card
                      key={index}
                      className={`rounded-lg transition-colors cursor-pointer ${defaultCard === el?.id ? 'bg-[#3F3F3F] border-none' : 'bg-[#282828]  border-none'
                        }`}
                      hoverable>
                      <Radio value={el?.id} className='w-full'>
                        <div style={{ width: '325px' }} className='flex items-center justify-between'>
                          <div className='flex items-center'>
                            {renderCardIcon(el?.card_type)}
                            <div className='ml-3'>
                              <p className='text-white text-sm font-semibold'>{el?.card_type}</p>
                              <p className='text-[rgba(255, 255, 255, 0.48)] text-xs font-normal'>****{el?.last_four_digit}</p>

                              {isExpired(el?.expired_at).expired && (
                                <div className='flex items-center'>

                                  <ErrorIcon style={{
                                    width: '15px',
                                    color: '#E53E3E'
                                  }} />

                                  <p className='text-xs font-normal text-[#E53E3E] ml-1'> {t('Pay.ExpiredAt')} {isExpired(el?.expired_at).formattedDate}</p>
                                </div>

                              )}

                            </div>
                          </div>

                          {!el?.is_default && (
                            <img onClick={() => {
                              onDeleteCard.mutate(el?.id)
                            }} src={Delete} alt="" />
                          )}

                        </div>


                      </Radio>
                    </Card>
                  ))}




                </Space>



              </Radio.Group>
              <p className='mt-4 mb-4'>{t('Or')}</p>
            </>

          )}



          <CustomButton className='max-w-max' buttonColor="secondary" onClick={() => {
            setIsAddCard(true)
          }}>
            <div className='flex'>
              <p className='mr-2'>+</p>
              {t('Pay.AddPaymentMethod')}
            </div>

          </CustomButton>


          {cards?.length > 0 && (
            <div
              className={`flex gap-2 pt-10 justify-end`}
            >


              <CustomButton
                style={{ flex: '1' }} buttonColor="secondary" onClick={closeModal}>
                {t('Cancel')}
              </CustomButton>
              <CustomButton
                style={{ flex: '1' }}
                onClick={() => {
                
                  setDefault.mutate(defaultCard)
                }}
              >
                {t('Update')}
              </CustomButton>
            </div>
          )}

        </>)}



      </Box>
    </ModalAdmin>
  )
}

export default ChangePaymentCardModal
